import { createURLSearchParams } from '../../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../../common/customAxios';

export interface IGetAppIsValidVersionProps {
  searchParam: {
    osType: string;
    version: string;
  };
}

export interface IGetAppIsValidVersionResponse {
  isValid: boolean;
}

export const getAppIsValidVersion = ({
  searchParam,
}: IGetAppIsValidVersionProps): Promise<IGetAppIsValidVersionResponse> => {
  const URLSearchParams = createURLSearchParams(searchParam);
  return customAxios.get(`/app/is-valid-version?${URLSearchParams}`);
};
